import * as React from 'react';
import { Figure, Iframe, Video } from './index.style';
import { eventTracking } from '../../utils';

const VIDEO_EXTENSIONS = ['webm', 'ogg', 'mp4', 'mkv', 'flv', 'vob', 'gif', 'gifv', 'avi', 'wmv'];

interface ArticlePrimaryVideoProps {
  src: string;
  caption?: string;
}

const ArticlePrimaryVideo = ({ src, caption }: ArticlePrimaryVideoProps) => {
  const isVideoFile = VIDEO_EXTENSIONS.some((extension) => src.endsWith(extension));
  return (
    <Figure
      onClick={() => {
        eventTracking('above-fold', 'navigate', 'video');
      }}
    >
      {isVideoFile ? <Video src={src} controls /> : <Iframe src={src} frameBorder="0" allowFullScreen />}
      {caption && <figcaption>{caption}</figcaption>}
    </Figure>
  );
};

export default ArticlePrimaryVideo;
